import { useEffect, useRef, useState } from "react";
import Icon from "../../../components/base/Icon";
import { useHub } from "../../../core/Global";
import { API_ROUTES } from "../../../core/Constants";
import ChatMessage from "../models/ChatMessage";




let chatSearchTypeTimeout: NodeJS.Timeout;

interface IProps {
    chatId: string
    onSearch: (data: ChatMessage[]) => void

}

export default function ChatSpecificSearch(props: IProps) {

    const hub = useHub()
    const searchChatInput = useRef<HTMLInputElement>(null)

    const [working, workingSet] = useState<boolean>(false)
    const [term, termSet] = useState<string>("")
    const [keyword, keywordSet] = useState<string>("")


    const search = () => {
        var q = "?";
        if (keyword.length > 1) {
            q += "keyword=" + encodeURIComponent(keyword);
        }
        hub.Get(API_ROUTES.ChatSearch + props.chatId + q,
            res => {
                props.onSearch(res.data);
                workingSet(false);
            })
    }

    useEffect(search, [keyword])

    useEffect(() => {
        if (term.length == 0) {
            keywordSet("");
            workingSet(false);
            return;
        }
        workingSet(true)
        const tm = setTimeout(() => {
            keywordSet(term);
        }, 700);
        return () => clearTimeout(tm)
    }, [term])


    useEffect(() => {
        searchChatInput.current?.focus()
    }, [])


    return (
        <form className="w-100 position-relative" autoComplete="off"
            onSubmit={e => e.preventDefault()}>
            <div className="d-flex align-items-center position-absolute" style={{ top: 15, right: 10 }}>
                {
                    term.length > 0 ?
                        <span className="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 translate-middle-y me-2 cursor-pointer"
                            onClick={e => {
                                termSet("");
                                searchChatInput.current?.focus();
                            }}>
                            <Icon icon="times" className="text-muted" size={18} />
                        </span>
                        :
                        <span className="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 translate-middle-y me-1">
                            <Icon icon="search" className="text-muted" size={18} />
                        </span>
                }
            </div>

            <input type="text"
                value={term} onChange={e => termSet(e.target.value)}
                ref={searchChatInput}
                className="form-control form-control-sm px-2 chat-searchbox"
                placeholder="Search..." />

        </form>
    )
}